const DEVICE_ID_KEY = "casaPwaPushDeviceId"

const createDeviceId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID()
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

export const getPushDeviceId = () => {
  const existingDeviceId = localStorage.getItem(DEVICE_ID_KEY)
  if (existingDeviceId) return existingDeviceId

  const deviceId = createDeviceId()
  localStorage.setItem(DEVICE_ID_KEY, deviceId)
  return deviceId
}

export const getClientInfo = () => ({
  userAgent: window.navigator.userAgent,
  platform: window.navigator.platform,
  language: window.navigator.language,
})
